import { Modal } from "ant-design-vue";
import { computed, watch } from "vue";
import { fmtMsg } from "vue-glcommonui";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { LostNetwork } from "@/locales/localeid";
import { showUnableJoinClassErrorNotification } from "@/utils/utils";
import { MODULES, vuexName } from "@/store/utils";
const STUDENT_LEAVE_ROOM_TIMING = 6000 * 10 * 5;
const TEACHER_LEAVE_ROOM_TIMING = 6000 * 10 * 3;
const TEACHER_PATH_REGEX = /\/teacher/;

export const useDisconnection = () => {
  const route = useRoute();
  const router = useRouter();
  const { getters } = useStore();
  let timeoutId: NodeJS.Timeout;
  const isStudentDisconnected = computed<boolean>(() => getters[vuexName(MODULES.STUDENT_ROOM.GETTERS.GET_IS_DISCONNECTED)]);
  const isTeacherDisconnected = computed<boolean>(() => getters[vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_IS_DISCONNECTED)]);
  const messageText = computed(() => fmtMsg(LostNetwork.StudentMessage));
  //handle teacher disconnection in teacher's side
  watch(isTeacherDisconnected, async (isDisconnected) => {
    const pathname = window.location.pathname;
    const matchIndex = pathname.search(TEACHER_PATH_REGEX);
    if (matchIndex < 0) {
      if (isDisconnected) {
        timeoutId = setTimeout(() => {
          if (isTeacherDisconnected.value) {
            showUnableJoinClassErrorNotification(10);
            router.push("/teacher");
          }
        }, TEACHER_LEAVE_ROOM_TIMING);
      } else {
        const { classId } = route.params;
        if (!classId) {
          window.location.reload();
        }
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
      }
    }
  });

  //handle student disconnection
  watch(isStudentDisconnected, async (isDisconnected) => {
    if (isDisconnected) {
      timeoutId = setTimeout(async () => {
        if (isStudentDisconnected.value) {
          Modal.warning({
            content: messageText.value,
            onOk: () => {
              //
            },
          });
        }
      }, STUDENT_LEAVE_ROOM_TIMING);
    } else {
      clearTimeout(timeoutId);
    }
  });
};
